import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../../../shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup } from '@angular/forms';
import { CommonService } from '../../../../../shared/services/common.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { BehaviorSubject, Subject, Subscription, merge, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, switchMap, takeUntil, catchError, map } from 'rxjs/operators';
import { MSMEParticipant } from '../../../../../shared/models/ParticipantMSME';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


@Component({
  selector: 'app-veiwenrolledmsme',
  templateUrl: './veiwenrolledmsme.component.html',
  styleUrl: './veiwenrolledmsme.component.css'
})
export class VeiwenrolledmsmeComponent {

  private destroy$ = new Subject<void>();
  private loadDataSubscription: Subscription = new Subscription();

  dataSource = new MatTableDataSource<MSMEParticipant>([]);
  displayedColumns: string[] = [
    'serialNumber', 'eventId', 'udyamNumber',
    'nameOfEnterprise', 'userName', 'userMobileNo',
    'userEmail', 'status'
  ];

  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';

  pageSizeOptions: number[] = [10, 20, 50, 100];
  page = 1;
  pageSize = 20;
  length: number = 0;
  displayedData: any[] = [];
  allrecord: any[] = [];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;
  uniqueEventId: any;

  viewMSMEParticipantForm: FormGroup;

  dtoPagination = {
    UniqueEventId: '',
    PageNumber: 1,
    PageSize: 20,
    SortColumn: '',
    SortDirection: '',
    SearchTerm: '',
    SearchCol: ''
  };

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    public commonService: CommonService
  ) {
    this.viewMSMEParticipantForm = new FormGroup({
      search: new FormControl('')
    });
  }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.uniqueEventId = params['eventid']; //'SantComp_SkilDev_89'; //
    });
    this.dtoPagination.UniqueEventId = this.uniqueEventId;
    this.dtoPagination.PageSize = 20;
    this.dtoPagination.SearchCol = this.commonService.searchText;
  }

  ngAfterViewInit() {
    this.loadData();
  }

  loadData() {
    if (!this.pagination) return;

    // Unsubscribe from previous subscription to prevent multiple API calls
    this.loadDataSubscription.unsubscribe();

    // Reset subscription with a new request
    this.loadDataSubscription = merge(
      this.sort.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.pagination.pageIndex = 0;
          this.dtoPagination.SortColumn = this.sort.active;
          this.dtoPagination.SortDirection = this.sort.direction;
          this.dtoPagination.SearchCol = this.commonService.searchText;

          return this.apiService.getRequest(API_ENDPOINTS.IA.GETENROLLEDMSMELISTFORIA, this.dtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            this.length = resp.totalRecords;
          }
          return resp?.data || {};
        })
      )
      .subscribe(data => {

        this.dataSource = data;

        this.adjustPaginator();
      });
  }

  onSearchClick(searchValue: string): void {

    const searchControl = this.viewMSMEParticipantForm.get('search');
    searchControl?.markAsTouched();

    if (searchControl?.valid && searchValue.trim() !== '') {
      this.dtoPagination.SearchTerm = searchValue.trim();
      this.dtoPagination.SearchCol = this.commonService.searchText;

      this.loadData();
    }
  }

  resetPage() {
    this.dtoPagination.SearchTerm = "";
    this.dtoPagination.SearchCol = this.commonService.searchText;

    this.loadData()
  }

  onPageChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    this.dtoPagination.PageNumber = this.pageIndex + 1;
    this.dtoPagination.PageSize = this.pageSize;

    this.loadData();
  }

  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages > 0 ? totalPages - 1 : 0;
      this.pagination.pageIndex = this.pageIndex;
    }
  }

  ngOnDestroy() {
    this.loadDataSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  exportToExcel(): void {
    const fileName = 'MSME_Participant_List.xlsx';

    const DtoPagination = {
      UniqueEventId: this.uniqueEventId,
      PageNumber: 1,
      PageSize: 9999999,
      SortColumn: "",
      SortDirection: "",
      SearchTerm: "",
      SearchCol: this.commonService.searchText,
    };

    this.apiService.getRequest(API_ENDPOINTS.IA.GETENROLLEDMSMELISTFORIA, DtoPagination).subscribe(
      result => {
        if (result.status) {
          this.allrecord = result.data;

          if (!this.allrecord || this.allrecord.length === 0) {
            this.toastr.error('No data available to export.');
            return;
          }

          // 👇 Match the Angular table columns
          const excelData = this.allrecord.map((item, index) => ({
            'Sr.No': item.serialNumber,
            'Event ID': item.eventId,
            'Udyam Number': item.udyamNumber,
            'Name of Enterprise': item.nameOfEnterprise,
            'Name': item.userName,
            'Mobile Number': item.userMobileNo,
            'Email': item.userEmail,
            'Status': item.status,
          }));

          const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

          // Column widths based on expected data length
          const columnWidths = [
            { wch: 8 },   // Sr.No
            { wch: 15 },  // Event ID
            { wch: 25 },  // Udyam Number
            { wch: 30 },  // Name of Enterprise
            { wch: 25 },  // Name
            { wch: 18 },  // Mobile Number
            { wch: 30 },  // Email
            { wch: 15 },  // Status
          ];
          worksheet['!cols'] = columnWidths;

          const workbook: XLSX.WorkBook = {
            Sheets: { 'Participant List': worksheet },
            SheetNames: ['Participant List'],
          };

          const excelBuffer: any = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
          });

          const data: Blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
          });

          saveAs(data, fileName);
          this.toastr.success('Excel exported successfully!');
        }
      }
    );
  }





  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, fileName);
  }
}
